import { useMemo, type ReactNode } from "react"
import { Link, Navigate, Outlet, useLocation } from "react-router"

import { useAuth } from "@/auth/AuthProvider"
import { NavbarTabList, navbarTabClass } from "@/components/NavbarTabs"
import { useNavbarLeftAction, usePageTitle } from "@/layouts/pageChrome"

export function CreosAdminOnly({ children }: { children: ReactNode }) {
  const { isAdmin } = useAuth()
  if (!isAdmin) {
    return <Navigate to="/creos/uniquify" replace />
  }
  return <>{children}</>
}

export default function CreosLayout() {
  const { pathname } = useLocation()
  const { isAdmin } = useAuth()
  const uniquify = pathname.startsWith("/creos/uniquify")
  const hidePicker = pathname.startsWith("/creos/uniquify/batch/")

  usePageTitle("", "CreOS")

  const navbarTabs = useMemo(() => {
    if (hidePicker) return null
    return (
      <NavbarTabList>
        <Link to="/creos/uniquify" className={navbarTabClass(uniquify)}>
          Uniquify
        </Link>
        {isAdmin ? (
          <Link to="/creos" className={navbarTabClass(!uniquify)}>
            Generate
          </Link>
        ) : null}
      </NavbarTabList>
    )
  }, [hidePicker, isAdmin, uniquify])
  useNavbarLeftAction(navbarTabs)

  if (!isAdmin && !uniquify) {
    return <Navigate to="/creos/uniquify" replace />
  }

  return (
    <div className="space-y-6">
      <Outlet />
    </div>
  )
}
